import React, { useState, useEffect, MouseEvent } from "react";
import clsx from "clsx";
import Icon from "./Icon";
import { isTouchDevice } from "../../lib/utils";
import styles from "../../styles/components/atoms/Select.module.scss";

interface SelectProps {
  className?: string;
  name?: string;
  onChange?: (e: any) => void;
  initial?: string;
  icon?: string;
  label?: string;
  defaultValue?: any;
  title?: string;
  dark?: boolean;
  grey?: boolean;
  white?: boolean;
  full?: boolean;
  half?: boolean;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  float?: boolean;
  required?: boolean;
  disabled?: boolean;
  options: {
    value: string;
    label: string;
    order?: string;
    suffix?: string;
  }[];
}

export default function Select(props: SelectProps) {
  const {
    name,
    initial,
    required,
    icon,
    dark,
    grey,
    white,
    defaultValue,
    options,
    onChange,
    label,
    small,
    medium,
    large,
    className,
  } = props;
  const size = large ? "large" : medium ? "medium" : small ? "small" : "";
  const color = dark ? "dark" : grey ? "grey" : "white";
  const { select } = styles;
  const [value, setValue] = useState() as any;
  const classes = clsx(select, styles[size], styles[color], className);

  const handleSelect = (e: any) => {
    const currValue = e.target.value;
    setValue(currValue);
    if (!!onChange) {
      onChange(e);
    }
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div className={classes}>
      {!!icon && <Icon name={icon} />}
      <label>
        {!!label && <span>{label}</span>}
        <div>
          <select
            name={name}
            onChange={handleSelect}
            value={value || ""}
            required={required}
          >
            {!(required && !!defaultValue) && (
              <option value="" data-value="">
                {" "}
                {initial || "Please select"}
              </option>
            )}
            {options.map((el, i) => (
              <option key={i} value={el.value} data-order={el.order}>
                {el.label}
                {!!el.suffix && el.suffix}
              </option>
            ))}
          </select>
        </div>
      </label>
    </div>
  );
}
